<template>
  <footer class="site-footer">
    <div class="footer-container">
     
      <!-- 中间列：导航链接 -->
      <div class="footer-col" v-for="(col, index) in navColumns" :key="index">
        <h3 class="footer-heading">{{ col.title }}</h3>

        <ul class="footer-links">
          <li v-for="link in col.links" :key="link">
             <router-link :to="link.path">
              {{ link.name }}
            </router-link>
          </li>
        </ul>

        <!-- ✅ 社交图标：只在 Contact us 下显示 -->
        <div v-if="col.title === 'Contact us'" class="social-icons about-social">
          <a href="https://www.linkedin.com/in/%E6%98%8E-%E5%B0%8F-455554414/" target="_blank" rel="noopener noreferrer" class="icon" aria-label="LinkedIn"> <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg> </a> 
          <a href="https://www.instagram.com/xcl_machine?igsh=MWw0MWkwZDB4bHV5NQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" class="icon" aria-label="Instagram"> <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg> </a> 
          <a href="https://www.facebook.com/profile.php?id=61590420762480" target="_blank" rel="noopener noreferrer" class="icon" aria-label="Facebook"> <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.737-.9 10.125-5.864 10.125-11.854z"/></svg> </a> 
          <a href="https://www.tiktok.com/@sundychen8?_r=1&_t=ZT-96qB7ftiCRZ" target="_blank" rel="noopener noreferrer" class="icon" aria-label="TikTok"> <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .89.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg> </a>
        </div>
      </div>
    </div>

    <!-- 底部版权（居中） -->
    <div class="footer-bottom-wrapper">
      <div class="footer-bottom">
        Copyright © XCL. All rights reserved
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      navColumns: [
        {
          title: 'Capabilities',
          links: [
            { name: '3D Printing', path: '/3d-printing' },
            { name: 'CNC Machining', path: '/cnc-machining' },
            { name: 'Die Casting', path: '/die-casting' },
            { name: 'Sheet Metal', path: '/sheet-metal' },
            { name: 'Compression Molding Services', path: '/compression-molding' }
          ]
        },
        {
          title: 'Industries',
          links: [
            { name: 'Aerospace', path: '/industries/aerospace' },
            { name: 'Automotive', path: '/industries/automotive' },
            { name: 'Consumer products', path: '/industries/consumer-products' },
            { name: 'Medical', path: '/industries/medical' },
            { name: 'Robotics', path: '/industries/robotics' },
            { name: 'Electronics', path: '/industries/electronics' },
            { name: 'Semiconductor', path: '/industries/semiconductor' },
            { name: 'New Energy', path: '/industries/new-energy' }
          ]
        },
        {
          title: 'About Us',
          links: [
            { name: 'About Company', path: '/about-company' },
            { name: 'Quality Management', path: '/quality-management' },
            { name: 'FAQ', path: '/faq'}
          ]
        },
        {
          title: 'Contact us',
          links: [
            { name: '+86 19129363409', path: '' },
            { name: 'sundy.xcl@gmail.com', path: '' }
          ]
        },
      ]
    }
  }
}
</script>

<style scoped>
/* =====================
   默认样式 (PC端: >= 1024px)
   ===================== */
.site-footer {
  background: #fff;
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto;
}

.footer-container {
  display: flex;
  justify-content: center;   /* 整体内容块居中 */
  flex-wrap: wrap;
  gap: 80px;                 /* 控制列之间间距 */
}

.footer-col {
  flex: 0 0 auto;   /* 不拉伸，宽度由内容决定 */
  min-width: 160px;
}

.footer-heading {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #4a4a4a;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
}

.footer-links a:hover {
  color: #0e957b;
}

/* 社交图标（Contact us 下） */
.about-social {
  margin-top: 40px;
  margin-left: 2px;
  display: flex;
  gap: 12px;
}

.icon {
  color: #4a4a4a;
  transition: 0.2s;
}

.icon:hover {
  color: #16bc9c;
}

/* 底部居中 */
.footer-bottom-wrapper {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.footer-bottom {
  text-align: center;
  font-size: 14px;
  color: #555;
}

/* =====================
   公用小屏居中样式 (< 1024px)
   ===================== */
@media (max-width: 1023px) {
  .footer-container {
    gap: 40px; 
  }

  .footer-col {
    text-align: center; /* 让所有标题和链接文字居中 */
  }

  .about-social {
    justify-content: center; /* 让社交图标居中排列 */
    margin-left: 0; 
  }
}

/* =====================
   平板屏幕：强制双列居中 (768px - 1023px)
   ===================== */
@media (min-width: 768px) and (max-width: 1023px) {
  .footer-col {
    /* 强制为双列：50%宽度减去gap的一半，以防换行 */
    flex: 0 0 calc(50% - 20px); 
  }
}

/* =====================
   手机屏幕：强制单列居中 (< 768px)
   ===================== */
@media (max-width: 767px) {
  .footer-col {
    /* 强制为单列，防止极窄屏幕下仍然因为 min-width 并排 */
    flex: 0 0 100%; 
  }
}
</style>